import { History } from "history";

//#region Toggle Block User

export const TOGGLE_BLOCK_USER_CONSENT: any = "TOGGLE_BLOCK_USER_CONSENT";
export const TOGGLE_BLOCK_USER = "TOGGLE_BLOCK_USER";
export const TOGGLE_BLOCK_USER_SUCCESS: any = "TOGGLE_BLOCK_USER_SUCCESS";
export const TOGGLE_BLOCK_USER_ERROR: any = "TOGGLE_BLOCK_USER_ERROR";

export interface ToggleBlockUserConsentAction {
  type: typeof TOGGLE_BLOCK_USER_CONSENT;
  payload: string;
}

export interface ToggleBlockUserAction {
  type: typeof TOGGLE_BLOCK_USER;
  payload: {
    id: string;
    state: boolean;
    history: History;
  };
}

export interface ToggleBlockUserSuccessAction {
  type: typeof TOGGLE_BLOCK_USER_SUCCESS;
  payload: null;
}

export interface ToggleBlockUserErrorAction {
  type: typeof TOGGLE_BLOCK_USER_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | ToggleBlockUserAction
  | ToggleBlockUserSuccessAction
  | ToggleBlockUserErrorAction;
